import { render, staticRenderFns } from "./ProfileMyProfileAcceptDwollaTermsModal.vue?vue&type=template&id=85fb32f8&scoped=true&"
import script from "./ProfileMyProfileAcceptDwollaTermsModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileMyProfileAcceptDwollaTermsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fb32f8",
  null
  
)

export default component.exports